// src/app/admin/myhtml.ts
import { Component, Injectable, OnDestroy } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Annotations } from 'src/app/models/StreamingModels';
import { BackendService } from 'src/app/services/backend.service'; // Adjust your real path location
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';

@Injectable({
    providedIn: 'root' // <-- This automatically registers it with Angular so you never get a NullInjectorError
})
@Component({
  selector: 'app-annotations',
  templateUrl: './annotations.component.html',
  styleUrls: ['./annotations.component.css']
})
export class AnnotationsComponent implements OnDestroy {
    private activePopup: Window | null = null;
    private messageListener: any;
    private currentRecordingId: number = 0;
    private currentCaseDetailsId: number | null = null;
    private fetchLiveAudioTimeFn: (() => number) | null = null;

    constructor(private backendService: BackendService,private route: ActivatedRoute,
        private spinner: NgxSpinnerService,
    ) {
    (window as any).onAnnotationSaved = async (data: any) => {
    console.log("Action request received from popup:", data.action, data);

    let exactAudioTime = 0;
    if (this.fetchLiveAudioTimeFn && data.action !== 'DELETE') {
        exactAudioTime = this.fetchLiveAudioTimeFn();
    }

    // Map your base object layout
    const annotationdetails: Annotations = {
        id: data.id || 0,
        timeStamp: data.timeStamp,
        speaker: data.speaker,
        comments: data.comments,
        recordingSessionId: this.currentRecordingId,
        sourceType: "Web",
        audioTime: exactAudioTime,
        caseDetailsId: this.currentCaseDetailsId
    };

    // ROUTE BASED ON ACTIONS
    switch (data.action) {
      case "ADD":
        console.log("Executing Add API...", annotationdetails);
        this.addAnnotation(annotationdetails);
        break;

      case "EDIT":
        console.log("Executing Update API for ID:", annotationdetails.id, annotationdetails);
        this.addAnnotation(annotationdetails); // Reusing addAnnotation for both Add and Edit since backend can differentiate by ID
        break;

      case "DELETE":
        console.log("Executing Delete API for ID:", annotationdetails.id);
        this.backendService.deleteAnnotation(annotationdetails).subscribe({
          next: () => console.log("Deleted successfully from DB")
        });
        break;
      case "REFRESH":
        console.log("Executing Refresh Annotation:", annotationdetails.id);
        this.reloadAndSyncPopupTable(annotationdetails.recordingSessionId);
        break;
        
      default:
        console.warn("Unknown action received:", data.action);
    }
  };




        // Bind the listener scope to cleanly parse postMessage actions
        //  (window as any).onAnnotationSaved = async (data: any) => {
        //     console.log("onAnnotationSaved Data received from Annotation window:", data);
        //     let exactAudioTime = 0;
        //     if (this.fetchLiveAudioTimeFn) {
        //         exactAudioTime = this.fetchLiveAudioTimeFn();
        //     }
        //     const annotationdetails: Annotations = {
        //         timeStamp: data.timeStamp,
        //         speaker: data.speaker,
        //         comments: data.comments,
        //         recordingSessionId: this.currentRecordingId,
        //         sourceType: "Web",
        //         audioTime: exactAudioTime
        //     };
        //     console.log("onAnnotationSaved before save:", annotationdetails);
        //     this.addAnnotation(annotationdetails);
        // };
    }
    ngoninit(): void {

    }
    /**
     * Orchestrates launching the window layout centrally. 
     * Call this directly from Component A or Component B buttons.
     */
    public async loadAnnotations(recordingId: number): Promise<any> {
        try {
            const data = await firstValueFrom(this.backendService.getAnnotationsbyRecordingId(recordingId));
            console.log("Annotations loaded successfully:", data);
            const res = this.backendService.getJSONResponse(data);
            return res.data;
        } catch (error) {
            console.error("Error fetching annotations:", error);
            return []; // Return fallback empty array on error
        }
    }
    async openAnnotationWindow(data: any) {
        console.log('Opening annotation ts with data model:', data);
        if (data && data.getLiveAudioTime) {
            this.fetchLiveAudioTimeFn = data.getLiveAudioTime;
        }

        this.currentRecordingId = data.annotationDialogModel.recordingId;
        this.currentCaseDetailsId = data.annotationDialogModel.caseDetailsId ?? null;
        //build model
        var annotationsList: Annotations[] = await this.loadAnnotations(this.currentRecordingId);
        console.log("Loaded annotations for recording ID", this.currentRecordingId, ":", annotationsList);
        const dataModel = {
            annotationDialogModel: data.annotationDialogModel,
            annotationsList: annotationsList // Your second model
        };

        // The app uses HTML5 (path) routing, NOT hash routing, so the URL must
        // not contain "/#/". A large JSON payload is also unsafe to put in the
        // query string (URL length limits), so persist it in localStorage and
        // only pass a lightweight key in the URL. The popup reads it back on load.
        const dataModelKey = `annotationDataModel_${this.currentRecordingId}`;
        localStorage.setItem(dataModelKey, JSON.stringify(dataModel));

        const url = `${window.location.origin}/annotation?dataModelKey=${encodeURIComponent(dataModelKey)}`;
        const title = 'Annotation Tool';
        const w = 1400;
        const h = 700;
        const left = (window.screen.width / 2) - (w / 2);
        const top = (window.screen.height / 2) - (h / 2);

        this.activePopup = window.open(
            url,
            title,
            `toolbar=no, location=no, directories=no, status=no, menubar=no, 
       scrollbars=yes, resizable=yes, copyhistory=no, 
       width=${w}, height=${h}, top=${top}, left=${left}`
        );

        if (this.activePopup) {
            this.activePopup.focus();
        }
        this.spinner.hide()
    }
    closeAnnotationWindow(): void {
        console.log("Request to close annotation window received.");
        if (this.activePopup && !this.activePopup.closed) {
            this.activePopup.close();
            this.activePopup = null; // Clear the reference
            console.log("Annotation window closed successfully.");
        } else {
            console.log("No active annotation window found or it was already closed by the user.");
        }
    }
    setCurrentCaseDetailsId(caseDetailsId: number | null): void {
        this.currentCaseDetailsId = caseDetailsId;
    }
    // async addAnnotation(annotationdetails: Annotations) {
    //     // Add annotation to server
    //     console.log("Add/edit annotation in ts:", annotationdetails);
    //     var response = await this.backendService.saveAnnotation(annotationdetails).toPromise();
    //     console.log('💾  Add/edit Annotataion result', response);
    // }
    // async deleteAnnotation(annotationdetails: Annotations) {
    //     // Add annotation to server
    //     console.log("delete annotation in ts:", annotationdetails);
    //     //var response = await this.backendService.deleteAnnotation(annotationdetails).toPromise();
    //     //console.log('💾  delete Annotataion result', response);
    // }
    async addAnnotation(annotationdetails: Annotations) {
    try {
        // console.log("Add/edit annotation in ts:", annotationdetails);
        
        // 1. Wait for the server to finish saving/updating
        var response = await this.backendService.saveAnnotation(annotationdetails).toPromise();
        console.log('💾 Add/edit Annotation result', response);

        // 2. Trigger the list reload immediately
        await this.reloadAndSyncPopupTable(annotationdetails.recordingSessionId);
    } catch (error) {
        console.error("Error saving annotation:", error);
    }
}

async deleteAnnotation(annotationdetails: Annotations) {
    try {
        console.log("delete annotation in ts:", annotationdetails);
        
        // 1. Wait for the server to delete the record
        var response = await this.backendService.deleteAnnotation(annotationdetails).toPromise();
        console.log('💾 delete Annotation result', response);

        // 2. Trigger the list reload immediately
        await this.reloadAndSyncPopupTable(annotationdetails.recordingSessionId);
    } catch (error) {
        console.error("Error deleting annotation:", error);
    }
}

/**
 * NEW HELPER METHOD: Fetches the fresh database list and pushes it down
 */
async reloadAndSyncPopupTable(recordingSessionId: number) {
    try {
        console.log(`Fetching updated list for session: ${recordingSessionId}...`);
        
        // 1. Fetch the fresh array from your backend service
        const freshList = await this.backendService.getAnnotationsbyRecordingId(this.currentRecordingId).toPromise();
        
        // 2. Check if our HTML popup window is open and active
        if (this.activePopup && !this.activePopup.closed) {
            console.log("Pushing fresh database entries down to open popup via postMessage...");
            
            // 3. SECURE FIX: Broadcast the data down using the window message channel
            this.activePopup.postMessage({
                type: 'REFRESH_TABLE_DATA',
                payload: freshList
            }, window.location.origin);
        }
    } catch (error) {
        console.error("Error reloading annotations list:", error);
    }

}
    ngOnDestroy() {
        // Clean up event listeners when the component destroys to avoid memory leaks
        window.removeEventListener('message', this.messageListener);
    }
}